import { render } from "./PlansPlanCard.vue?vue&type=template&id=75dbb9f9&scoped=true&ts=true"
import script from "./PlansPlanCard.vue?vue&type=script&lang=ts"
export * from "./PlansPlanCard.vue?vue&type=script&lang=ts"

import "./PlansPlanCard.vue?vue&type=style&index=0&id=75dbb9f9&lang=scss&scoped=true"

import exportComponent from "C:\\Bohdan\\telesim_test\\telesim-admin-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75dbb9f9"]])

export default __exports__